import Amplify from "aws-amplify";
// @ts-ignore
import awsExports from "./aws-exports";
import { Toaster } from "react-hot-toast";
import { RecoilRoot } from "recoil";
import Router from "./App/Router";

import "./App.scss";

Amplify.configure(awsExports);

localStorage.theme = "light";

const App = () => {
  return (
    <>
      <RecoilRoot>
        <Router />
      </RecoilRoot>
      <Toaster
        position="top-right"
        toastOptions={{
          success: {
            style: {
              background: "#d5ffd9",
            },
          },
          error: {
            style: {
              background: "#ffd5d5",
            },
          },
        }}
      />
    </>
  );
};

export default App;
